import { reqGet, TArrayItemsCallback } from 'HttpRequests'
import { IProductInStore } from './IProduct'

function reqGetAllProducts(callback: TArrayItemsCallback<IProductInStore>) {
  reqGet('api/get_all_products/', callback)
}

export { reqGetAllProducts }
